import React from 'react';

import PropTypes from 'prop-types';

// Components
import { Mui } from 'components';

const BUNDLER_STATES = [
  { value: true, label: 'Ligado', text: 'a família paga só os itens; o kit não tem preço.' },
  {
    value: false,
    label: 'Desligado',
    text: 'o kit também é cobrado pelo preço dele, além dos itens.',
  },
];

const useStyles = Mui.makeStyles(theme => ({
  state: { color: theme.palette.text.secondary },
  current: { color: theme.palette.text.primary, fontWeight: theme.typography.fontWeightBold },
}));

function KitBundlerSwitch({ checked, disabled, onChange }) {
  // Hooks
  const classes = useStyles();

  return (
    <>
      <Mui.FormControlLabel
        control={
          <Mui.Switch
            color="primary"
            disabled={disabled}
            checked={checked}
            onChange={event => onChange(event.target.checked)}
          />
        }
        label={<Mui.Typography variant="body2">Kit agrupador</Mui.Typography>}
      />
      {BUNDLER_STATES.map(state => (
        <Mui.Typography
          key={state.label}
          variant="caption"
          component="div"
          className={state.value === checked ? classes.current : classes.state}>
          {state.label}: {state.text}
        </Mui.Typography>
      ))}
    </>
  );
}

KitBundlerSwitch.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default KitBundlerSwitch;
